
<script>
import moment from 'moment'

export default {
  name: 'rates',
  data: () => ({
    date: null
  }),
  computed: {
    isUserLoggedIn() {
      return this.$store.getters['account/getAccess']
    },
    rates() {
      return this.$store.getters['rates/getRate']('RUB')
    },
    hasErrors() {
      return this.$store.getters['rates/hasErrors']
    }
  },
  created() {
    this.date = moment().format('DD.MM.YYYY')

    this.$store.dispatch('rates/getRates', {
      currenciesFrom: ['USD', 'EUR'],
      currenciesTo: ['RUB'],
      date: this.date
    })
  }
}
</script>

<template>
  <div class="app-header__exchange">
    <p class="app-header__exchange-title">
      Туроператор ярких впечатлений
    </p>
    <div
      v-if="!hasErrors"
      class="app-header__exchange-list"
    >
      <p class="app-header__exchange-item">
        {{ date }}
      </p>
      <p class="app-header__exchange-item">
        USD {{ rates.USD }}
      </p>
      <p class="app-header__exchange-item">
        EUR {{ rates.EUR }}
      </p>
    </div>
    <div
      v-if="hasErrors"
      class="app-header__exchange-list"
    >
      <p class="app-header__exchange-item">
        Не удалось загрузить курсы валют
      </p>
    </div>
  </div>
</template>
